import {fromResult, toEither} from 'Core/models/Async';
import {Email} from 'Core/models/Email';
import * as E from 'fp-ts/lib/Either';
import {flow} from 'fp-ts/lib/function';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import UsernameRecoveryEmailSent from 'Users/components/UserRecovery/UsernameRecoveryEmailSent';
import UsernameRecoveryForm from 'Users/components/UserRecovery/UsernameRecoveryForm';
import * as UsernameRecoveryActions from 'Users/ducks/userRecovery';
import './UsernameRecovery.sass';

type UsernameRecoveryProps = typeof UsernameRecoveryActions & ReturnType<typeof mapStateToProps>;

const UsernameRecovery = (props: UsernameRecoveryProps) => {
  useEffect(
    () => () => {
      props.clear();
    },
    []
  );

  const renderEmailForm = (email: Email) => (
    <UsernameRecoveryForm
      onChangeEmail={newEmail =>
        props.changeEmail(UsernameRecoveryActions.UserEmailRecoveryAddress.email(fromResult(newEmail)))
      }
      onSubmit={props.recoverUsername}
      email={email}
    />
  );

  const RecoveryComponent = UsernameRecoveryActions.UserEmailRecoveryAddress.match({
    email: flow(
      toEither,
      E.fold(error => <div className="username-recovery__form">{renderAsync(error)} </div>, renderEmailForm)
    ),
    recoveryEmailSent: () => <UsernameRecoveryEmailSent />,
  });

  return <div className="username-recovery">{RecoveryComponent(props.email)}</div>;
};

const mapStateToProps = (state: ReducerState) => ({
  email: state.user.userRecovery.email,
});

export default connect(mapStateToProps, {...UsernameRecoveryActions})(UsernameRecovery);
